module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/196-tajikistan-d4e8ea92ae2581dc7f5b84e8c62de383.svg";